import Validator from 'validatorjs';
import { privateNotes, caseActions } from './rules';




const validatePrivateNotes = (values) => {
  const validation = new Validator(values, privateNotes);
  validation.setAttributeNames({
    notes: 'notes'
  });
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

const validateCaseAction = (values) => {
  const validation = new Validator(values, caseActions);
    validation.setAttributeNames({
      controlNumber: 'control number'
    });

    let errors = {};
    if (!validation.passes()) {
      errors = validation.errors.all();
    }

  return customCaseActionValidation(values, errors);
};

const customCaseActionValidation = (values, errors) => {

  // let controlNumber = values.controlNumber;
  // if(!(controlNumber > 9999999 && controlNumber < 100000000)) {
  //    errors.controlNumber = ["Control number must be 8 digits"];
  // }
  return errors;
};


export {
  validatePrivateNotes,
  validateCaseAction
};